<template>
  <svg
    width="24"
    height="30"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="settings" clip-path="url(#clip0_320_230)">
      <path
        id="Vector"
        d="M18.8285 8.02796H16.519C16.3492 7.27534 16.0467 6.57437 15.6483 5.93981L17.2863 4.30175C17.5446 4.0435 17.5446 3.61553 17.2863 3.35728L16.15 2.22097C15.8918 1.96272 15.4638 1.96272 15.2056 2.22097L13.5675 3.85903C12.9329 3.46058 12.232 3.15806 11.4793 2.98835V0.671456C11.4793 0.302524 11.1768 0 10.8079 0H9.19934C8.83041 0 8.52788 0.302524 8.52788 0.671456V2.98097C7.77526 3.15068 7.07429 3.44583 6.43973 3.85165L4.80167 2.21359C4.54342 1.95534 4.11546 1.95534 3.85721 2.21359L2.72089 3.3499C2.46264 3.60816 2.46264 4.03612 2.72089 4.29437L4.35895 5.93243C3.96051 6.56699 3.65798 7.26796 3.48827 8.02058H1.17138C0.802448 8.02058 0.499924 8.32311 0.499924 8.69204V10.3006C0.499924 10.6695 0.802448 10.972 1.17138 10.972H3.48089C3.6506 11.7247 3.94575 12.4256 4.35157 13.0602L2.71352 14.6983C2.45526 14.9565 2.45526 15.3845 2.71352 15.6427L3.84983 16.779C4.10808 17.0373 4.53604 17.0373 4.79429 16.779L6.43235 15.141C7.06691 15.5394 7.76788 15.8419 8.52051 16.0117V18.3212C8.52051 18.6901 8.82303 18.9926 9.19196 18.9926H10.8005C11.1694 18.9926 11.472 18.6901 11.472 18.3212V16.0117C12.2246 15.8419 12.9256 15.5394 13.5601 15.141L15.1982 16.779C15.4564 17.0373 15.8844 17.0373 16.1426 16.779L17.279 15.6427C17.5372 15.3845 17.5372 14.9565 17.279 14.6983L15.6409 13.0602C16.0393 12.4256 16.3419 11.7247 16.5116 10.972H18.8211C19.19 10.972 19.4925 10.6695 19.4925 10.3006V8.69204C19.4925 8.32311 19.19 8.02058 18.8211 8.02058L18.8285 8.02796ZM9.99623 13.2373C7.93759 13.2373 6.25526 11.5623 6.25526 9.49631C6.25526 7.43029 7.93021 5.75534 9.99623 5.75534C12.0623 5.75534 13.7372 7.43029 13.7372 9.49631C13.7372 11.5623 12.0623 13.2373 9.99623 13.2373Z"
        fill="var(--icon-primary, var(--grey800))"
      />
    </g>
    <defs>
      <clipPath id="clip0_320_230">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="translate(0.499924)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
